import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots } from "@fortawesome/pro-solid-svg-icons";
import React, { useEffect, useRef } from "react";
import styled from "styled-components";

declare global {
  interface Window {
    dxe?: {
      server: string;
    };
    dxbot?: {
      publish<T extends Record<string, unknown>>(
        event: string,
        payload: T | null,
        options?: {
          broadcastChannel?: boolean;
          dispatchEvent?: boolean;
          nativeEvent?: boolean;
        },
      ): void;
      subscribe(
        event: string,
        callback: <T extends Record<string, unknown>>(payload: T) => void,
      ): void;
      unsubscribe(
        event: string,
        callback: <T extends Record<string, unknown>>(payload: T) => void,
      ): void;
    };
  }
}

const ChatContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;

  #kpd_koopidtag {
    visibility: visbile !important;
  }
`;

const ChatButton = styled.button`
  width: 60px;
  height: 60px;
  cursor: pointer;
  border-radius: 50%;
  border: none;
  background-color: #2563eb;
  color: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
`;

const teardown = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any)?.dxbot?.publish("TEARDOWN_CHATBOT", {});
  const hostElement = document.querySelector(
    `#host-b258121192874e41a5f8dd06bd842355`,
  );
  if (hostElement) {
    hostElement.remove();
  }
};

const setup = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any)?.dxbot?.publish("SETUP_CHATBOT", {
    channelId: "b258121192874e41a5f8dd06bd842355",
    providerEmail: "4956959908970496@billiontoone.com",
    isTryNow: false,
  });
};

// Here are the docs for this chatbot:
// https://help.dialpad.com/docs/create-a-webchat-channel#deploy-a-webchat-channel
// Note, this is different from their AI chatbot feature.
export const ChatWidget = (): React.ReactElement => {
  useEffect(() => {
    const addGlobalVars = () => {
      const script = document.createElement("script");
      script.id = "dx-chatbot-script-window";
      script.appendChild(
        document.createTextNode(
          `window.dxe = { "server": 'https://us-central.dx.dialpad.com' };`,
        ),
      );
      document.body.appendChild(script);
    };

    const globalVarScript = document.getElementById("dx-chatbot-script-window");
    if (!globalVarScript) {
      addGlobalVars();
    }

    const addScript = () => {
      const script = document.createElement("script");
      script.async = true;
      script.id = "dx-chatbot-script";
      script.src =
        "https://us-central.dx.dialpad.com/dxclient/dist/dialpad-chatbot.es.js";
      script.type = "module";
      script.onload = () => {
        // required: setup a new client instance
        setup();
      };
      document.head.appendChild(script);
    };

    const botScript = document.getElementById("dx-chatbot-script");
    if (!botScript) {
      addScript();
    } else {
      // required: teardown any client instances

      teardown();
      // required: setup a new client instance
      setup();
    }

    return () => {
      // optional: teardown any client instances
      teardown();
    };
  }, []);

  return (
    <ChatContainer id="chat-container dx_chatbot_fab_wrapper_id">
      <ChatButton
        id="dx_chatbot_fab_id"
        data-dxchannelid="b258121192874e41a5f8dd06bd842355"
        data-dxprovemail="4956959908970496@billiontoone.com"
      >
        <FontAwesomeIcon icon={faCommentDots} />
      </ChatButton>
    </ChatContainer>
  );
};
